import { createSlice } from '@reduxjs/toolkit';
import { IPageState } from '../../../types/referral/page';

const initialState: IPageState = {
  modal: {
    modalFormOpen: false,
    modalSource: null,
  },
  stickyScrollBtnVisible: false,
};

const referralPageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setReferralModalFormOpen(state, action) {
      state.modal.modalFormOpen = true;
      state.modal.modalSource = action.payload;
    },
    setReferralModalFormClose(state) {
      state.modal.modalFormOpen = false;
      state.modal.modalSource = null;
    },
    toggleReferralStickyScrollBtn(state, action) {
      state.stickyScrollBtnVisible = action.payload;
    },
  },
});

export const {
  reducer: referralPageReducer,
  actions: { setReferralModalFormOpen, setReferralModalFormClose, toggleReferralStickyScrollBtn },
} = referralPageSlice;
